(function () {
	'use strict';

	var $infoBox = $('.js-question');

	$infoBox.on('click', function() {
		var $self = $(this),
			$target = $self,
			targetOpened = !!$target.hasClass('expand');

		// Close all boxes
		$infoBox.removeClass('expand');

		// Check current box for toggle
		if (targetOpened) {
			$target.removeClass('expand');
		} else {
			$target.addClass('expand');
		}
	});

})();
